<template>
    <span v-if="this.value" class="text-success">
        <i class="far fa-check-circle"></i>
    </span>
    <span v-else class="text-danger">
        <i class="far fa-times-circle"></i>
    </span>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faCheckCircle, faTimesCircle} from '@fortawesome/free-regular-svg-icons';
    library.add(faTimesCircle, faCheckCircle);

    export default {
        name: "CheckIcon",
        props: {
            value: {
                type: Boolean | String,
                required: true,
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>
